import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';

import asyncComponent from '../../../util/asyncComponent';


const Osc = ({match}) => (
    <div className="app-wrapper">
        <Switch>
            <Redirect exact from={`${match.url}/`} to={`${match.url}/dashboard`}/>
            <Route path={`${match.url}/dashboard`} component={asyncComponent(() => import('./routes/Dashboard'))}/>
            <Route path={`${match.url}/list-delivery-order`} component={asyncComponent(() => import('./routes/ListDeliveryOrder'))}/>
            <Route path={`${match.url}/list-shipment`} component={asyncComponent(() => import('./routes/ListShipment'))}/>
            <Route path={`${match.url}/sign-in`} component={asyncComponent(() => import('./routes/SignIn'))}/>
            <Route path={`${match.url}/pool`} component={asyncComponent(() => import('./routes/Pool'))}/>
            <Route path={`${match.url}/register`} component={asyncComponent(() => import('./routes/SignUp'))}/>
            <Route path={`${match.url}/vehicle-in`} component={asyncComponent(() => import('./routes/VehicleIn'))}/>
            <Route path={`${match.url}/vehicle-out`} component={asyncComponent(() => import('./routes/VehicleOut'))}/>
            <Route component={asyncComponent(() => import('components/Error404'))}/>
        </Switch>
    </div>
);

export default Osc;


// WEBPACK FOOTER //
// ./app/routes/Osc/index.js